module.exports = __webpack_public_path__ + "resources/img/main_banner10_m.176c8dd9e194c80307ce627e70147d38.png";